// @ts-nocheck
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';

@Component({
  selector: 'lbca-input-checkmark',
  templateUrl: './input-checkmark.component.html',
  styleUrl: './input-checkmark.component.scss',
  imports: [],
})
export class InputCheckmarkComponent implements AfterViewInit {
  private dynamicFormService = inject(DynamicFormService);

  public isDisabled: boolean = false;
  public options: any[] = [];
  public isCheckedItens: boolean = false;
  public entityKey: string = '';
  @ViewChild('optionsContainer') optionsContainer!: ElementRef<HTMLDivElement>;

  @Input('disabled') set disable(val) {
    this.isDisabled = val;
  }

  @Input('options') set optionsList(val) {
    this.options = val;
  }

  @Input() set checked(val: 'all' | 'none' | 'almost') {
    if (val === 'almost' || !val) return;
    this.isCheckedItens = val === 'all' ? true : false;
  }
  @Input('entityKey') set setEntityKey(val) {
    this.entityKey = val;
  }

  @Output('changeValue') change = new EventEmitter();
  public elements!: any;

  ngAfterViewInit(): void {
    this.optionsContainer.nativeElement.childNodes.forEach((x: any) => {
      if (x['tagName'] === 'LABEL') this.elements = { id: x.getAttribute('for'), element: x };
    });
    if (this.dynamicFormService.formControlStructure?.fieldControl?.[this.entityKey]?.value) {
      const { value } = this.dynamicFormService.formControlStructure.fieldControl[this.entityKey];
      if (Array.isArray(value) && value.length > 0) {
        const elementValue = value.filter((x: any) => x.id === this.elements.id);
        if (elementValue.length > 0) {
          setTimeout(() => {
            this.isCheckedItens = true;
          });
        }
      }
    }
  }

  public selectOption($event, option) {
    this.isCheckedItens = !this.isCheckedItens;
    const obj: any = { id: option.id, operation: 'remove' };
    if (this.isCheckedItens) obj.operation = 'add';

    this.change.emit(obj);
  }
}
